import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { eventService } from '../services/eventService';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import Doacao from './Doacao';
import './Dashboard.css';

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDoacao, setShowDoacao] = useState(false);

  useEffect(() => {
    loadEvents();
  }, []);

  useEffect(() => {
    // Se for colaborador e tiver eventos, redirecionar para o evento
    if (user?.isCollaborator && events.length > 0) {
      navigate(`/events/${events[0].id}`);
    }
  }, [user, events, navigate]);

  const loadEvents = async () => {
    try {
      const data = await eventService.getAll();
      setEvents(data.events);
    } catch (error) {
      toast.error('Erro ao carregar eventos');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este evento?')) return;

    try {
      await eventService.delete(id);
      toast.success('Evento excluído com sucesso');
      loadEvents();
    } catch (error) {
      toast.error('Erro ao excluir evento');
    }
  };

  const handleNovoEvento = (e) => {
    e.preventDefault();
    setShowDoacao(true);
  };

  const handleContinuarParaEvento = () => {
    setShowDoacao(false);
    navigate('/events/new');
  };

  // Se está mostrando a página de doação
  if (showDoacao) {
    return <Doacao onContinue={handleContinuarParaEvento} />;
  }

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="container">
        <div className="dashboard-header">
          <div>
            <h1>{user?.isCollaborator ? 'Meu Evento' : 'Meus Eventos'}</h1>
            {user?.isCollaborator && (
              <p style={{ fontSize: '0.875rem', color: 'var(--text-light)', marginTop: '0.5rem' }}>
                Permissão: <strong>
                  {user.role === 'viewer' && '👁️ Visualizador'}
                  {user.role === 'editor' && '✏️ Editor'}
                  {user.role === 'manager' && '👔 Gerente'}
                </strong>
              </p>
            )}
          </div>
          {!user?.isCollaborator && (
            <button onClick={handleNovoEvento} className="btn btn-primary">
              + Novo Evento
            </button>
          )}
        </div>

        {events.length === 0 ? (
          <div className="empty-state">
            <p>📅</p>
            <h2>{user?.isCollaborator ? 'Nenhum evento atribuído' : 'Nenhum evento cadastrado'}</h2>
            <p>{user?.isCollaborator ? 'Aguarde ser adicionado a um evento' : 'Comece criando seu primeiro evento'}</p>
            {!user?.isCollaborator && (
              <button onClick={handleNovoEvento} className="btn btn-primary">
                Criar Evento
              </button>
            )}
          </div>
        ) : (
          <div className="events-grid">
            {events.map((event) => (
              <div key={event.id} className="event-card">
                {event.image_url && (
                  <div className="event-card-image">
                    <img
                      src={`${process.env.REACT_APP_API_URL?.replace('/api', '')}${event.image_url}`}
                      alt={event.title}
                    />
                  </div>
                )}
                <div className="event-card-content">
                  <h3>{event.title}</h3>
                  <p className="event-date">
                    📅 {format(new Date(event.start_date), 'dd/MM/yyyy HH:mm')}
                  </p>
                  <p className="event-location">📍 {event.location}</p>
                  <p className="event-registrations">
                    👥 {event.registrations_count || 0}
                    {event.max_attendees && ` / ${event.max_attendees}`} inscritos
                  </p>
                </div>
                <div className="event-card-actions">
                  <Link to={`/events/${event.id}`} className="btn btn-sm btn-outline">
                    Ver Detalhes
                  </Link>
                  {!user?.isCollaborator && (
                    <button
                      onClick={() => handleDelete(event.id)}
                      className="btn btn-sm btn-danger"
                    >
                      Excluir
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
